import createValues from '../createValues';
import immutable from '../structure/immutable';

export default createValues(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/values.js
// module id = 1212
// module chunks = 0